var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMassageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 24 24",
    height: "24px",
    viewBox: "0 0 24 24",
    width: "24px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_12"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_13"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_14"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_15"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_16"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_17"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_18"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_19"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_20"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_21"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,2H4C2.897,2,2,2.897,2,4v18l5.333-4H20c1.103,0,2-0.897,2-2V4C22,2.897,21.103,2,20,2z M20,16H6.667L4,18V4h16V16z    M18,9H6V7h12V9z M15,13H6v-2h9V13z"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_22"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_23"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_24"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_25"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMassageIcon);
export default __webpack_public_path__ + "static/media/massageIcon.10221523b3554400d985ff6a317b6b59.svg";
export { ForwardRef as ReactComponent };